/**
 * Extracts context from container's data-chatkit-* attributes
 * Converts camelCase to snake_case and parses numbers
 *
 * Example:
 *   data-chatkit-preview-id="123" -> { preview_id: 123 }
 *   data-chatkit-case-id="456" -> { case_id: 456 }
 */
export function extractContextFromDataset(container) {
  const context = {};

  Object.keys(container.dataset).forEach((key) => {
    if (key.startsWith('chatkit') && key !== 'chatkitType') {
      // Convert camelCase to snake_case: chatkitPreviewId -> preview_id
      const contextKey = key
        .replace(/^chatkit/, '')
        .replace(/([A-Z])/g, '_$1')
        .toLowerCase()
        .replace(/^_/, '');

      const value = container.dataset[key];
      context[contextKey] = isNaN(value) ? value : parseInt(value, 10);
    }
  });

  return context;
}
